export function setLanguage(payload) {
  return {
    type: "SET_LNG",
    payload,
  };
}
